import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavPaymentsIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M16.5 15.8332C16.4998 15.6952 16.388 15.5832 16.25 15.5832H3.75C3.61204 15.5832 3.50018 15.6952 3.5 15.8332V16.2502C3.5 16.3882 3.61193 16.5002 3.75 16.5002H16.25C16.3881 16.5002 16.5 16.3882 16.5 16.2502V15.8332ZM9.76953 2.03629C9.94439 1.97983 10.1351 1.98924 10.3047 2.06461L17.5547 5.28727C17.8254 5.40768 18 5.67648 18 5.97281V7.58317C18 7.99738 17.6642 8.33317 17.25 8.33317H2.75C2.33579 8.33317 2 7.99738 2 7.58317V5.97281C2 5.67648 2.17456 5.40768 2.44531 5.28727L9.69531 2.06461L9.76953 2.03629ZM3.5 6.45914V6.83317H16.5V6.45914L10 3.57047L3.5 6.45914ZM18 16.2502C18 17.2167 17.2165 18.0002 16.25 18.0002H3.75C2.7835 18.0002 2 17.2167 2 16.2502V15.8332C2.00018 14.8668 2.78361 14.0832 3.75 14.0832H16.25C17.2164 14.0832 17.9998 14.8668 18 15.8332V16.2502Z"
          fill="inherit"
        />
        <path
          d="M11 12.266V10.0002C11 9.58603 11.3358 9.25024 11.75 9.25024C12.1642 9.2503 12.5 9.58607 12.5 10.0002V12.266C12.4999 12.6801 12.1641 13.016 11.75 13.016C11.3359 13.016 11.0001 12.6801 11 12.266ZM15 12.266V10.0002C15 9.58614 15.3359 9.25042 15.75 9.25024C16.1642 9.25024 16.5 9.58603 16.5 10.0002V12.266C16.4999 12.6801 16.1641 13.016 15.75 13.016C15.336 12.0159 15.0001 12.68 15 12.266Z"
          fill="inherit"
        />
        <path
          d="M3 10.0002V12.2659C3.00012 12.68 3.33586 13.0159 3.75 13.0159C4.16414 13.0159 4.49988 12.68 4.5 12.2659V10.0002C4.5 9.58594 4.16421 9.25016 3.75 9.25016C3.33579 9.25016 3 9.58594 3 10.0002Z"
          fill="inherit"
        />
        <path
          d="M7 10.0002V12.2659C7.00012 12.6799 7.33606 13.0157 7.75 13.0159C8.16414 13.0159 8.49988 12.68 8.5 12.2659V10.0002C8.5 9.58594 8.16421 9.25016 7.75 9.25016C7.33599 9.25039 7 9.58609 7 10.0002Z"
          fill="inherit"
        />
      </g>
    </SvgWrapper>
  );
}
